import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CheckCircle2 } from 'lucide-react';
const tomosData = [{
  icon: '📘',
  title: 'TOMO 1: ADIÓS A LA HINCHAZÓN',
  subtitle: 'El Reset Digestivo en 72 Horas',
  topics: ['Por qué tu panza reacciona a tus nervios (y cómo cortarlo)', 'La Lista Roja completa: los alimentos que te inflaman hoy', 'El Protocolo de 72 Horas: el Barrido Intestinal Natural', 'Tu Menú de Emergencia para los días sin tiempo', 'Las 5 infusiones más desinflamantes disponibles en Argentina', 'Checklist de acción inmediata día por día'],
  value: '$11.000'
}, {
  icon: '📗',
  title: 'TOMO 2: PAZ EN DOS MINUTOS',
  subtitle: 'El Reset del Sistema Nervioso',
  topics: ['Qué es el nervio vago y cómo "resetearlo" en 2 minutos', 'El test de cortisol para saber si tu sistema está en emergencia', 'Las 5 herramientas antipánico para usar en cualquier lugar', 'Suplementación real y barata disponible en farmacias argentinas', 'La Rutina AM de 15 minutos que cambia tu biología', 'La Rutina PM que baja el cortisol antes de dormir'],
  value: '$11.000'
}, {
  icon: '📙',
  title: 'TOMO 3: ENERGÍA REAL',
  subtitle: 'El Reset de Vitalidad Sin Estimulantes',
  topics: ['Los 7 ladrones de energía ocultos en tu rutina diaria', 'Alimentación densa: cómo comer para no tener sueño a las 4 PM', 'Los sustitutos del café que realmente funcionan', 'El movimiento que recarga en lugar de agotar', 'El Ciclo de Recarga Biológica (los 3 sistemas integrados)', 'Plan de mantenimiento para no volver a colapsar nunca más'],
  value: '$11.000'
}];
export function TomoDetails() {
  return <section className="py-20 relative bg-brand-cream" data-id="element-373">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-374">
        <FadeIn data-id="element-375">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12 text-brand-dark" data-id="element-376">
            📚 ¿QUÉ INCLUYE?
          </h2>
        </FadeIn>

        <div className="space-y-8" data-id="element-377">
          {tomosData.map((tomo, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-378">
              <div className="bg-brand-card border border-brand-border border-t-[3px] border-t-brand-terracotta rounded-2xl p-8 shadow-card" data-id="element-379">
                <div className="flex items-start gap-4 mb-6" data-id="element-380">
                  <span className="text-3xl shrink-0" data-id="element-381">{tomo.icon}</span>
                  <div data-id="element-382">
                    <h3 className="text-xl font-bold text-brand-dark mb-1" data-id="element-383">
                      {tomo.title}
                    </h3>
                    <p className="text-brand-accent font-medium" data-id="element-384">
                      {tomo.subtitle}
                    </p>
                  </div>
                </div>

                <div className="bg-brand-cream p-6 rounded-xl mb-6" data-id="element-385">
                  <p className="font-bold text-brand-dark mb-4" data-id="element-386">
                    ✅ Lo que vas a aprender:
                  </p>
                  <div className="space-y-3" data-id="element-387">
                    {tomo.topics.map((topic, j) => <div key={j} className="flex items-start gap-3" data-id="element-388">
                        <CheckCircle2 className="w-5 h-5 text-brand-accent shrink-0 mt-0.5" data-id="element-389" />
                        <span className="text-brand-dark" data-id="element-390">{topic}</span>
                      </div>)}
                  </div>
                </div>

                <p className="text-brand-muted text-sm" data-id="element-391">
                  Valor individual:{' '}
                  <span className="font-bold text-brand-dark" data-id="element-392">
                    {tomo.value} ARS
                  </span>
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="text-center mt-12" data-id="element-393">
          <div className="bg-brand-card border-2 border-brand-accent rounded-2xl p-8 shadow-md" data-id="element-394">
            <p className="text-2xl font-bold text-brand-dark mb-2" data-id="element-395">
              VALOR TOTAL DEL CONTENIDO
            </p>
            <p className="text-xl text-[#AAAAAA] line-through mb-1" data-id="element-396">
              $33.000 ARS
            </p>
            <p className="text-4xl font-bold text-brand-terracotta" data-id="element-397">
              $19.990 ARS
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}